import { ModelSagres } from "../../model-sagres";

export class CargoResumido extends ModelSagres {
  Id: number;
  Codigo: string;
  Nomenclatura: string;
  IdTipoVinculo: number;
  QuantidadeVagas: number;
  IdSituacaoCargoTce: number;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.Id = obj.Id;
      this.Codigo = obj.Codigo;
      this.Nomenclatura = obj.Nomenclatura;
      this.IdTipoVinculo = obj.IdTipoVinculo;
      this.QuantidadeVagas = obj.QuantidadeVagas;
      this.IdSituacaoCargoTce = obj.IdSituacaoCargoTce;
    }
  }
}
